import { render, staticRenderFns } from "./ModalAdminRatingInfo.vue?vue&type=template&id=1e70d885&"
import script from "./ModalAdminRatingInfo.vue?vue&type=script&lang=js&"
export * from "./ModalAdminRatingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports